import {useDispatch, useSelector} from "react-redux";
import {financeSelector} from "../../../../../../redux/slices/financeSlice";
import {globalDataSelector} from "../../../../../../redux/slices/globalDataSlice";
import {checkPixelTokenValid, pixelApiSelector, postPixelApiItem} from "../../../../../../redux/slices/pixelApiSlice";
import useCustomSnackbar from "../../../../../../hooks/useCustomSnackbar";
import {useTranslation} from "react-i18next";
import {getUser} from "../../../../../../storage/user";
import React, {useEffect} from "react";
import s from './setUniqueExtraMarkPopup.module.scss'
import {useFormik} from "formik";
import * as Yup from "yup";
import {snackbar_error, snackbar_success} from "../../../../../../utils/vars/staticVariables";
import {pixelIdExists} from "../../../../../../utils/vars/errorMessages";
import SvgSelector from "../../../../../../components/SvgSelector/SvgSelector";
import CancelButton from "../../../../../../components/UiKit/Buttons/CancelBtn/CancelBtn";
import PrimaryBtn from "../../../../../../components/UiKit/Buttons/PrimaryBorderBtn/PrimaryBorderBtn";
import {subscriptionSelector} from "../../../../../../redux/slices/subscriptionSlice";
import {extraMarkRatiosArray} from "../../SubscriptionsAccountingTr";
import {subscriptionsAccountingSelector} from "../../../../../../redux/slices/subscriptionsAccountingSlice";

const SetExtraMarkDetailPopup = ({active, setActive, extraMarkDetail, setExtraMarkDetailHandler}) => {
    const {topUpBalanceIsActive} = useSelector(financeSelector);
    const {exitPopup, isCollapsedSidebar} = useSelector(globalDataSelector);
    const {setExtraMarkDetailPending} =
        useSelector(subscriptionsAccountingSelector);

    const dispatch = useDispatch();

    const showSnackbar = useCustomSnackbar();

    const {t} = useTranslation();


    useEffect(() => {
        if (topUpBalanceIsActive || exitPopup) {
            setActive(false);
        }
    }, [topUpBalanceIsActive, exitPopup]);

    useEffect(() => {
        const handleEscClose = (e) => {
            if (e.key === "Escape") {
                setActive(false);
                if (document.activeElement) {
                    document.activeElement.blur();
                }
            }
        };

        document.addEventListener("keydown", handleEscClose);

        return () => {
            document.removeEventListener("keydown", handleEscClose);
        };
    }, [setActive]);

    const handleClosePopup = (event) => {
        if (event.target.classList.contains(s.popupWrapper)) {
            setActive(false);
        }
    };

    const formik = useFormik({
        initialValues: {
            extra_mark_detail: extraMarkDetail || '',
        },
        validationSchema: Yup.object({
            extra_mark_detail: Yup.string()
                .trim()
                .required(t("requiredField")),
        }),
        onSubmit: async (
            values,
            {setFieldError, validateField, setFieldValue},
        ) => {
            setExtraMarkDetailHandler(values?.extra_mark_detail)
        },
    });

    return (
        <div
            className={`${s.popupWrapper} ${active ? s.active : ""} ${isCollapsedSidebar === "true" ? s.collapsed : ""}`}
            onClick={handleClosePopup}
        >
            <form
                className={active ? `${s.popup} ${s.active}` : s.popup}
                onSubmit={formik.handleSubmit}
            >
                <div className={s.header}>
                    <button
                        onClick={() => setActive(false)}
                        className={s.closePopup}
                        type="button"
                    >
                        <SvgSelector id="close-popup"/>
                    </button>
                    <div className={s.icon}>
                        <SvgSelector id="note-popup-icon"/>
                    </div>
                    <div className={s.popupInfo}>
                        <p className={s.title}>{t("description_of_extra_status")}</p>
                    </div>
                </div>
                <div className={s.body}>
                    <div>
                        <p className={s.inputName}>{t('status')}</p>
                        <input
                            type="text"
                            name="extra_mark_detail"
                            className={`${s.textInput} ${
                                formik.touched.extra_mark_detail && formik.errors.extra_mark_detail ? s.error : ""
                            }`}
                            placeholder={t("placehoder_type_text")}
                            value={formik.values.extra_mark_detail}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                        />
                        {formik.touched.extra_mark_detail && formik.errors.extra_mark_detail ? (
                            <div className={s.error}>{formik.errors.extra_mark_detail}</div>
                        ) : null}
                    </div>
                </div>
                <div className={s.footerContainer}>
                    <CancelButton
                        text={t("button_cancel")}
                        action={() => setActive(false)}
                    />
                    <PrimaryBtn
                        text={t("button_save")}
                        submit={true}
                        pending={setExtraMarkDetailPending}
                    />
                </div>
            </form>
        </div>
    );
};

export default SetExtraMarkDetailPopup;